import { Injectable } from '@angular/core';
import {HashLocationStrategy} from "@angular/common";

@Injectable()
export class CustomlocationstrategyService extends HashLocationStrategy {
    prepareExternalUrl(internal: string): string {    	
        const url = this.getBaseHref() + '#' + internal;
        return url;
    }
}



// WEBPACK FOOTER //
// D:/deliverproject/eatasiafood/src/app/customlocationstrategy.service.ts